import BaseActionFilter from 'yoda-core-components/lib/helpers/Analytics/BaseActionFilter';
import {
    getDeviceType,
    getVersion,
    serviceErrorToAnalyticsFormat,
} from 'yoda-account-components/lib/analytics/DigitalAnalyticsHelper';

class AppointmentActionFilter extends BaseActionFilter {
    // pattern pitching!
    getAppointmentPageDL(store) {
        const { context } = store.getState();
        const exclusionPageDL = this.updateCommonDigitalData();

        const pageInfo = {
            pageName: 'my appointments',
            releaseVersion: context.__RELEASEVERSION__,
            version: getVersion('yoda account'),
            searchRedirect: '',
            pageType: 'account',
            siteSection: 'account',
            deviceType: getDeviceType(context),
        };

        const category = {
            primaryCategory: 'amount',
            subCategory1: '',
            subCategory2: '',
            department: 'account',
        };
        return {
            ...exclusionPageDL,
            error: serviceErrorToAnalyticsFormat({}),
            page: {
                ...exclusionPageDL.page,
                pageInfo: {
                    ...exclusionPageDL.page.pageInfo,
                    ...pageInfo,
                },
                category: {
                    ...exclusionPageDL.page.category,
                    ...category,
                },
            },
        };
    }
}

export default AppointmentActionFilter;
